import React from 'react';
import { Link as UiLink } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';
import { dateTimeFormat, safeFind } from '../../shared/misc/utils';
import { NotificationPopoverItem } from '../../services/types/Notification';
import { eventLinks } from './Notifications';
import { LinkButton } from '../../shared/components';

interface Props {
  notification: NotificationPopoverItem;
  markAsRead: (id: number, goTo?: string) => void;
  handleResultNavegation: (
    notificationId: number,
    navigationLink: string,
    wasRead: boolean
  ) => void;
}
const PopoverNotification: React.FC<Props> = ({
  notification,
  markAsRead,
  handleResultNavegation,
}) => {
  const { link } = safeFind(eventLinks, (e) => e.eventType === notification.event);
  const { id, operationNumber, shortDescription, createdOn, wasRead } = notification;

  const navigationLink = notification.navigationLink || `/operations/${operationNumber}${link}`;

  return (
    <div className="notification__popover__item">
      <div className="notification__popover__content">
        <LinkButton
          text={shortDescription}
          onClick={() => handleResultNavegation(id, navigationLink, wasRead)}
        />
        <p>{`${dateTimeFormat(createdOn)}`}</p>
      </div>

      <div className="notification__popover__options">
        {wasRead ? (
          <div role="presentation" onClick={() => markAsRead(id)}>
            <UiLink color="nothing" to="#">
              <FontAwesomeIcon className="visited" icon={faEnvelopeOpen} />
            </UiLink>
          </div>
        ) : (
          <div role="presentation" onClick={() => markAsRead(id)}>
            <UiLink color="nothing" to="#">
              <FontAwesomeIcon icon={faEnvelope} />
            </UiLink>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopoverNotification;
